<template>
    <button
        @click.prevent="setActiveTab"
        :class="{ '!opacity-100': activeTab === name && !error, 'bg-red-400 !text-white font-bold': error }"
        class="vue__tabs-button cursor-pointer border-b-0 opacity-60 bg-white hover:opacity-100 flex items-center gap-x-3 border hover:bg-white px-3 py-3 text-sm font-semibold text-gray-700 transition-opacity">
        <slot />
    </button>
</template>

<script setup>
import {computed, getCurrentInstance} from "vue";

let parent = getCurrentInstance().parent

while(typeof parent.exposed?.activeTab === 'undefined') {
    parent = parent.parent
}

const activeTab = computed(() => parent.exposed?.activeTab.value)

const props = defineProps({
    name: {
        type: [String, Number],
        required: true
    },
    error: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['update:modelValue', 'clicked'])

function setActiveTab() {
    parent.exposed.setActiveTab(props.name)
    emit('clicked')
}
</script>
